// extracted by mini-css-extract-plugin
export default {"container":"TextSection_container__af5IZ","title":"TextSection_title__sAxcE","text":"TextSection_text__rUxEj","blur1":"TextSection_blur1__Kw2MK","blur2":"TextSection_blur2__Anwpt"};